module.exports = __webpack_public_path__ + "fonts/DroidKufi-Regular.0b2c0e74.woff";